(function (app, ng) {

    app.controller("addEnrollmentController", addEnrollmentController);

    addEnrollmentController.$inject = ["$mdDialog", "$q", "_", "pipelineApi", "clientApi", "personApi", "enrollmentApi", "advisorApi"];
    function addEnrollmentController($mdDialog, $q, _, pipelineApi, clientApi, personApi, enrollmentApi, advisorApi) {
        var $ctrl = this;
        // window.test = this;

        ng.extend($ctrl,
            {
                ui: {

                },
                phoneNumber: {
                    Type: "Home"
                },
                emailAddress: {
                    Type: "Personal"
                },
                physicalAddress: {
                    Type: "Residence"
                },
                close: close,
                addEnrollment: addEnrollment,
                searchAdvisors: searchAdvisors
            });

        function close() { $mdDialog.cancel() };

        function addEnrollment() {
            $ctrl.ui.saving = true;
            $ctrl.client.Type = _.find($ctrl.clientTypes,
                function(type) {
                    return type.Id === $ctrl.client.TypeId;
                });
            $ctrl.client.PrimaryAdvisorId = $ctrl.client.PrimaryAdvisor.Id;

            clientApi.add($ctrl.client).then(function (client) {
                $ctrl.client = client;

                if (!!$ctrl.phoneNumber.Value && $ctrl.phoneNumber.Value.length === 10) {
                    personApi.addPhoneNumber(client.Id, $ctrl.phoneNumber);
                }

                if (!!$ctrl.emailAddress.Value) {
                    personApi.addEmailAddress(client.Id, $ctrl.emailAddress);
                }

                if (!!$ctrl.physicalAddress.Line1 && !!$ctrl.physicalAddress.City && !!$ctrl.physicalAddress.State && !!$ctrl.physicalAddress.PostalCode) {
                    personApi.addPhysicalAddress(client.Id, $ctrl.physicalAddress);
                }

                var enrollment = {
                    PipelineId: $ctrl.pipeline.Id,
                    PipeId: $ctrl.pipe.Id,
                    ClientId: client.Id,
                    Client: client,
                    AssignedUserId: $ctrl.currentUser.Id,
                    AssignedUser: $ctrl.currentUser
                }

                enrollmentApi.addClientEnrollment($ctrl.pipeline.Id, enrollment).then(function (response) {
                    if (!!response.Id) {
                        enrollment.Id = response.Id;
                    } else {
                        enrollment.Id = response;
                    }
                    $ctrl.ui.saving = false;

                    $mdDialog.hide(enrollment);
                });
            });
        }

        function searchAdvisors(term) {
            return advisorApi.searchAdvisors(term).then(function (result) {
                ng.forEach(result,
                    function (row) {
                        row.Term = row.Person.FirstName + " " + row.Person.LastName;
                    });
                return result;
            });
        }
    }

})(window.app, window.angular); //jshint ignore:line